import axios from 'axios';
import type {
  GetPresignedUploadUrlResponse,
  InspectionDto,
  InspectionPhase,
  InspectionShotKey,
} from '@carvia/ros-client-types';
import { httpClient } from './http-client';

class InspectionsService {
  endpoint = '/inspections';

  async getAllByBookingId(bookingId: string) {
    const res = await httpClient.get<InspectionDto[]>(this.endpoint, { params: { bookingId } });
    return res.data;
  }

  async start(allocationId: string, phase: InspectionPhase) {
    const res = await httpClient.post<InspectionDto>(this.endpoint, { allocationId, phase });
    return res.data;
  }

  async registerCapture(id: string, shotKey: InspectionShotKey, captureId: string) {
    const res = await httpClient.post<InspectionDto>(
      `${this.endpoint}/${id}/shots/${shotKey}/capture`,
      { captureId },
    );
    return res.data;
  }

  async skip(id: string, shotKey: InspectionShotKey, reason: string) {
    const res = await httpClient.post<InspectionDto>(
      `${this.endpoint}/${id}/shots/${shotKey}/skip`,
      { reason },
    );
    return res.data;
  }

  async attachImage(
    id: string,
    shotKey: InspectionShotKey,
    captureId: string,
    imageFileKey: string,
  ) {
    const res = await httpClient.post<InspectionDto>(
      `${this.endpoint}/${id}/shots/${shotKey}/image`,
      { captureId, imageFileKey },
    );
    return res.data;
  }

  async complete(id: string) {
    const res = await httpClient.post<InspectionDto>(`${this.endpoint}/${id}/complete`);
    return res.data;
  }

  async uploadImage(id: string, file: Blob) {
    const { data } = await httpClient.get<GetPresignedUploadUrlResponse>(
      `${this.endpoint}/${id}/upload-url`,
    );
    await axios.put(data.url, file, {
      headers: { 'Content-Type': file.type || 'image/jpeg' },
    });
    return { fileKey: data.fileKey };
  }
}

export const inspectionsService = new InspectionsService();
